<template>
  <v-dialog v-model="dialogShow" persistent max-width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="tipsDialog-mainAreaNoIcon">
        <p class="tipsDialog-mainAreaNoIcon-text">内容已提交，编辑后需要重新提交审核，确认编辑？</p>
        <div class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="editCreationOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确认</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: "EditCreationDialog",
  props:["dialogShow"],
  methods:{
    editCreationOK(){
      switch(this.$store.state.editCreationInfo.mainType){
        case 1:{
          let route = this.$router.resolve({
            path: "/createArticle",
            query: {
              creationId:this.$store.state.editCreationInfo.infoId
            }
          });
          window.open(route.href, '_blank');
          break;
        }
        case 3:{
          let route = this.$router.resolve({
            path: "/createVideo",
            query: {
              creationId:this.$store.state.editCreationInfo.infoId
            }
          });
          window.open(route.href, '_blank');
          break;
        }
      }
      this.hideDialog();

    },
    //隐藏弹窗
    hideDialog(){
      this.$emit("hideEditCreationDialog")
    }
  }
}
</script>

<style scoped>

</style>